import { render, staticRenderFns } from "./AddVisitRecordModal.vue?vue&type=template&id=f228c4fa&scoped=true"
import script from "./AddVisitRecordModal.vue?vue&type=script&lang=js"
export * from "./AddVisitRecordModal.vue?vue&type=script&lang=js"
import style0 from "./AddVisitRecordModal.vue?vue&type=style&index=0&id=f228c4fa&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f228c4fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f228c4fa')) {
      api.createRecord('f228c4fa', component.options)
    } else {
      api.reload('f228c4fa', component.options)
    }
    module.hot.accept("./AddVisitRecordModal.vue?vue&type=template&id=f228c4fa&scoped=true", function () {
      api.rerender('f228c4fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/mentalHealth/CrisisIntervent/components/AddVisitRecordModal.vue"
export default component.exports